import UnderConstruction from '../components/UnderConstruction';

function Calendar(props){
    return(
        <UnderConstruction/>
    )
}

export default Calendar;